// 1. QUERIES
enum UtilityKeys {
	readUtility = 'readUtility',
	listUtility = 'listUtility'
}
enum UtilityAccountsKeys {
	UtilityAccountsRead = 'UtilityAccountsRead',
	UtilityAccountsList = 'UtilityAccountsList'
}

enum OtherKeys {
	// utility.ts
	getAccountListByFacilityId = 'getAccountListByFacilityId',
	getAdminPortalUtilityAccountAccountsList = 'getAdminPortalUtilityAccountAccountsList',
	utilityInvoices = 'utilityInvoices',
	// utility_accounts.ts
	// utility.ts
	utilityFacilities = 'utilityFacilities',
	// utility_accounts.ts
	// alerts.ts
	// accounts.ts
	// manageClient.ts
	accountInfo = 'accountInfo',
}
/**
 * Represents the query keys for the application.
 */
export const QUERY_KEYS_SQL = Object.freeze({
	utility: UtilityKeys,
	utilityAccounts: UtilityAccountsKeys
});

/**
 * Represents the query keys for the application.
 */
export type QueryKeySql = 
	| UtilityKeys
	| UtilityAccountsKeys;